import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import axios from "axios";
import { loadSkills } from "./skills";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function downloadImage(storageApi, id) {
  return new Promise(resolve => {
    (async () => {
      try {
        const { data } = await storageApi({
          url: `/file/${id}/download_auth`,
          method: "GET",
          responseType: "blob"
        });

        let reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      } catch (e) {
        resolve(null);
      }
    })();
  });
}

export default async function(
  apollo,
  storageApi,
  applicant,
  profile,
  template = "Profil"
) {
  let data = {
    applicant,
    profile
  };

  if (profile.skillJobType) {
    data.skills = await loadSkills(apollo, profile.skillJobType.id, profile.id);
  }

  const {
    Header,
    Footer,
    Page,
    Content
  } = require(`./templates/${template}.js`);
  const response = await axios.get(
    require(`@/assets/images/resources/${template}.png`),
    { responseType: "blob" }
  );

  if (applicant.imageID) {
    data.applicantImage = await downloadImage(storageApi, applicant.imageID);
  }

  if (profile.consultant && profile.consultant.imageID) {
    data.consultantImage = await downloadImage(
      storageApi,
      profile.consultant.imageID
    );
  }

  let reader = new FileReader();
  reader.readAsDataURL(response.data);
  reader.onloadend = function() {
    pdfMake
      .createPdf({
        header: Header(reader.result),
        footer: Footer(data),
        ...Page(data),
        content: Content(data)
      })
      .open();
  };
}
